/**
 * 商品ページで縦スクロール時に横方向へずれるのを防ぐ（iOS Safari 向け）
 */
(function initProductHorizontalScrollLock() {
  if (!document.body.classList.contains('template-product')) return;

  let isResetting = false;

  const resetHorizontalScroll = () => {
    const scrollX = window.scrollX || document.documentElement.scrollLeft || 0;
    if (scrollX === 0 || isResetting) return;

    isResetting = true;
    window.scrollTo(0, window.scrollY);
    window.requestAnimationFrame(() => {
      isResetting = false;
    });
  };

  window.addEventListener('scroll', resetHorizontalScroll, { passive: true });
  document.addEventListener('touchend', resetHorizontalScroll, { passive: true });
  document.addEventListener('touchcancel', resetHorizontalScroll, { passive: true });
  window.addEventListener('orientationchange', resetHorizontalScroll);
})();
